import { useState } from "react";
import Config from "../../Config";
import Pricelist from "./Pricelist";
import Prefix from "./Prefix";
import Itc from "./Itc";





function Info800View(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


  
    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


 

      if(props.mainView.viewSelected == 'pricelist')
    {
        document.title ="Cennik"; 
        return (
            <div className="econtent ">                                  
                 <Pricelist  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }



    if(props.mainView.viewSelected == 'prefix')
    {
        document.title ="Prefix"; 
        return (
            <div className="econtent ">                                  
                 <Prefix  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }
 

  
     
    if(props.mainView.viewSelected == 'itc')
    {
        document.title ="Prefix"; 
        return (
            <div className="econtent ">                                  
                 <Itc  userData={props.userData}  mainView={props.mainView} keyListener={props.keyListener}   />
            </div>
        )
    }
     
  

        return (
        <div className="econtent ">
             Info800View - no selected menu position
        </div>
    );
}


export default Info800View ;